const adminClientsReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ADMINCLIENTS':
      return action.data
    default:
      return state
  }
}

export default adminClientsReducer
